import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { PRODUCTS } from "@/data/catalog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/keeper/checkins`;
const NOTICED = { plenty: "Noticed a difference", some: "A little", not_yet: "Not yet" };
const TONE = { plenty: "text-[#8FB08A]", some: "text-[#C9A96B]", not_yet: "text-[#D3CEC4]/55" };

export const KeeperCheckins = ({ token }) => {
  const [d, setD] = useState(null);
  const auth = { headers: { Authorization: `Bearer ${token}` } };
  const load = useCallback(() => {
    axios.get(API, { headers: { Authorization: `Bearer ${token}` } }).then((r) => setD(r.data)).catch(() => setD({ rows: [], summary: {} }));
  }, [token]);
  useEffect(() => { load(); }, [load]);
  const moderate = async (r, status) => {
    await axios.post(`${API}/${r.checkin_id}/${r.product_id}`, { status }, auth).catch(() => {});
    load();
  };

  if (!d) return <p className="mt-8 text-[#D3CEC4]/50">Reading the answers…</p>;
  const rows = Array.isArray(d.rows) ? d.rows : [];
  const s = d.summary || {};
  return (
    <div className="mt-6" data-testid="keeper-checkins">
      <p className="text-[14px] text-[#D3CEC4]/70" data-testid="checkins-summary">
        {s.sent ?? 0} check-ins sent · {s.answered ?? 0} answered · {s.awaiting ?? 0} shared notes awaiting you
      </p>
      <p className="mt-1 text-[12px] text-[#D3CEC4]/50">Approve only notes in the customer's own words that avoid treat, cure or prevent claims.</p>
      {rows.length === 0 ? (
        <p data-testid="checkins-empty" className="mt-8 font-display italic text-[#D3CEC4]/55">No answers yet. Check-ins go out 30 days after each order once email is switched on.</p>
      ) : (
        <ul className="mt-6 space-y-4">
          {rows.map((r) => (
            <li key={`${r.checkin_id}-${r.product_id}`} className="border border-[#303B2D]/70 rounded-sm p-5" data-testid={`checkin-${r.checkin_id}-${r.product_id}`}>
              <div className="flex flex-wrap justify-between gap-2 text-[13px]">
                <span className="text-[#E8DDC7]">{PRODUCTS.find((p) => p.id === r.product_id)?.name} · <span className={TONE[r.noticed]}>{NOTICED[r.noticed]}</span></span>
                <span className="text-[#D3CEC4]/55">{r.display_name} · {r.email} · {new Date(r.answered_at).toLocaleDateString("en-CA")}</span>
              </div>
              {r.note && <p className="mt-3 font-display italic text-[16px] text-[#D3CEC4]/85">"{r.note}"</p>}
              {r.share ? (
                <div className="mt-3 flex flex-wrap items-center gap-3">
                  <span className="text-[11px] uppercase tracking-[0.2em] text-[#D3CEC4]/55" data-testid={`checkin-state-${r.checkin_id}-${r.product_id}`}>{r.moderation}</span>
                  {r.moderation !== "approved" && <button onClick={() => moderate(r, "approved")} data-testid={`checkin-approve-${r.checkin_id}-${r.product_id}`} className="text-[11px] uppercase tracking-[0.2em] text-[#8FB08A] hover:text-[#E8DDC7] transition-colors">Show on the jar</button>}
                  {r.moderation !== "hidden" && <button onClick={() => moderate(r, "hidden")} data-testid={`checkin-hide-${r.checkin_id}-${r.product_id}`} className="text-[11px] uppercase tracking-[0.2em] text-[#C9876B] hover:text-[#E8DDC7] transition-colors">Keep private</button>}
                </div>
              ) : r.note && <p className="mt-2 text-[11px] uppercase tracking-[0.2em] text-[#D3CEC4]/45">Private · not for sharing</p>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
